export default {
    word1: "EBC Financial Group | Your Trusted, Prestigious, Licenced Broker",
    word2:
      "EBC Financial Group is a world-leading, trusted broker offering multi-asset class financial brokerage in forex, indices, shares, and commodities.",
    word3: `World's Best<span class="starLogo">*</span>Broker`,
    word4: `Best Trading Platform*, trusted in <span class="subtitle-20_medium md-body-14_medium">100+</span> countries`,
    word5: "Leverage",
    word6: "Popular trading products",
    word7: "Low spreads",
    word8:
      "EBC partners with UN Foundation to beat malaria",
    word9: "Shared Success Starts with Our Copy Trading Community",
    word10:
      "Copy top traders for free, or earn monthly payouts of up to 18% p.a. when followers copy your trades",
    word11: "Open & Transparent ",
    word12: "1-Click Copy Trade",
    word13: "Earn 18% p.a. in Rewards",
    word14: "Instant Trade Updates",
    word15: `EBC & Oxford <br class="pc"/>  Collaborationfor the <br class="pc"/>  Seminar`,
    word16:
      "Sustaining Sustainability: Balancing Economic Growth & Climate Resilience",
    word17: "Register Now",
    word18: "Learn More",
    word19: "Trade the Global Markets",
    word20:
      "Access 200+ instruments with institutional liquidity and competitive spreads for a superior trading experience.",
    word21: "Forex",
    word22: "Commodities",
    word23: "Indices",
    word24: "Stocks",
    word25: "ETFs",
    word26: "Trading Products",
    word27: "Bid",
    word28: "Ask",
    word29: "Spread",
    word30: "Leverage",
    word31: "View More",
    word32:
      "Over 87.6% of Our Clients' Orders Are Executed at a Better Price Than Requested",
    word33:
      "Our Liquidity Aggregation System outperforms traditional trading in price, speed, and consistency.",
    word34: "Orders Processed Per Second",
    word35: "Average Execution Speed",
    word36: "Stable Data Transmission",
    word37: "Institutional-Grade Spreads",
    word38: "Our order optimisation is ranked in the top 2.5% of the industry",
    word39: "Register Now",
    word40: "Trusted Globally for Secure Trading",
    word41:
      "Stringent regulations and comprehensive safeguards to protect every trade.",
    word42: "Backed by Trusted Financial Authorities",
    word43:
      "EBC Financial Group prioritises the safety of your funds above all else. Client funds held by our UK and Cayman entities are securely deposited with Tier One banking institutions worldwide. By strictly complying with FCA, CIMA, and ASIC regulations, participating in government-backed compensation schemes, and securing multiple firm-level insurance protections with Lloyd’s of London, we have built a robust, multi-layered framework designed to ensure your complete peace of mind.",
    word44: "Global Partnerships",
    word45:
      "We have established long-term, stable partnerships with over 25 internationally renowned banks and non-bank institutions, delivering genuine institutional-grade liquidity depth and low spreads from 0.0 pips. Beyond financial services, we actively embrace our corporate social responsibility through initiatives with the University of Oxford Department of Economics, collaborations with the World Association of Girl Guides and Girl Scouts, and joint efforts with the United Nations Foundation to promote a fairer and more sustainable society.",
    word46: "World-Class Global Regulations",
    word47: "FCA (UK)",
    word48: "EBC Financial Group (UK) Ltd is authorised",
    word49: "and regulated by the Financial Conduct Authority.",
    word50: "Reference number: 927552",
    word51: "CIMA (CAYMAN)\n",
    word52: "EBC Financial Group (Cayman) Ltd. is authorised and ",
    word53: "regulated by the Cayman Islands Monetary Authority (CIMA).",
    word54: " Reference number: 2038223",
    word55: "ASIC (AU)",
    word56: "EBC Financial Group (Australia) Pty Ltd is authorised",
    word57:
      "and regulated by the Australian Securities and Investments Commission.",
    word58: "Reference number: 500991",
    word59:
      "Each subsidiary of EBC Financial Group operates under strict regulation and holds top-tier licences within its respective jurisdiction. ",
    word60:
      "From the very first day of our establishment, we have upheld the highest standards of regulatory compliance, placing the safety of client assets at the core of our business. This forms our core, non-negotiable principle that defines our commitment to clients.",
    word61:
      "We work exclusively with leading banks, adhere rigorously to multi-jurisdictional regulatory frameworks, and enforce industry-leading risk management protocols. When it comes to security, transparency, and client trust, we have never — and will never — compromise.",
    word62: "Global Reach Backed by Local Support",
    word63: "Dedicated access and professional support, wherever you are.",
    word64: "Average Monthly Trading Volume (USD)",
    word65: "Registered Users (As of August 2025)",
    word66: "Trading Order Optimisation Gains in Q2 2025 (USD)",
    word67: "Available Countries",
    word68: "Contact Us",
    word69: "UK Team",
    word70: "EBC in the News",
    word71:
      "Access our latest updates, financial spotlights, and expert perspectives.",
    word74: "Get in Touch",
    word75: "Our dedicated account manager will reach out in XX working days",
    word76: "Submit",
    word77: "lots",
    word78: "pips",
    word79: "Others",
    word80: "Top 10 Most Popular Brokers",
    word81: "Most Transparent Broker",
    word82: "Most Highly Rated Broker",
    word83: "Excellence in Execution Broker",
    word84: "Global Best Trading Experience Award",
    word85: "Most Trusted Broker",
    word86: "Best CFD Broker",
    word87: "Global Best ECN Broker",
    word88: "Global Rising Star Broker",
    word89: "Best CFD Provider",
    word90: "best FX Trading Platform",
    word91: "best Trading Execution",
    word92: "World's Best Broker",
    word93: "Family Name/Nickname",
    word94: "Email Address",
    word95: "Mobile",
    word96: "Verification Code",
 
};
